import { createContext, useContext } from 'react';
import type { Key } from '../../../../types';
import type { SelectBaseProps } from './SelectBase';

type SelectContext = {
  registerDisabledItem: (key: Key) => void;
  size: SelectBaseProps['size'];
};

export const SelectContext = createContext<SelectContext | undefined>(
  undefined
);

export const useSelectContext = () => {
  const context = useContext(SelectContext);
  if (context === undefined) {
    throw new Error(
      'useSelectContext must be used within a SelectContext (which is available by using Select)'
    );
  }
  return context;
};
